import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
  Input,
  HostListener,
  ElementRef,
  ViewChild,
  Renderer2
} from '@angular/core';
import { DeparturePoint } from 'app/shared';
import { toggle } from 'app/shared/animations';
import { AlertService } from 'services/alert/alert.service';
import { FlightBoardService } from 'services/flight-board/flight-board.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-departure-list',
  templateUrl: './departure-list.component.html',
  styleUrls: ['./departure-list.component.css'],
  animations: [toggle]
})
export class DepartureListComponent implements OnInit, OnDestroy {
  @Input() departureTree: DeparturePoint;
  @Input() selectedDepartureNode: DeparturePoint;
  @Output() selectAction: EventEmitter<any> = new EventEmitter();
  @ViewChild('dropdown_content') dropdownContent: ElementRef;
  @ViewChild('dropdown_toggle') dropdownToggle: ElementRef;
  @ViewChild('flaticon_agree') flaticonAgree: ElementRef;
  @ViewChild('dropdown_toggle_btn') dropdownToggleBtn: ElementRef;

  opened: boolean = false;
  selectedName: string;
  selected: DeparturePoint;
  isMobile: boolean;
  isOneWay: boolean = false;

  private debounceTimer;
  private debounceDelay = 800;
  private subscriptions: Subscription[] = [];

  @HostListener('window:resize', ['$event'])
  onResize() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      if (window.innerWidth <= 650) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    }, this.debounceDelay);
  }

  constructor(
    private alertService: AlertService,
    private renderer: Renderer2,
    private flightBoardService: FlightBoardService
  ) {}

  ngOnInit() {
    this.isOneWay = localStorage.getItem('flightType') === 'one-way';
    this.subscriptions.push(
      this.flightBoardService.getIsOneWay().subscribe(value => {
        this.isOneWay = value;
      })
    );
    this.renderer.listen('window', 'click', (e: Event) => {
      if (
        e.target !== this.dropdownContent.nativeElement &&
        e.target !== this.dropdownToggleBtn.nativeElement &&
        e.target !== this.dropdownToggle.nativeElement &&
        e.target !== this.flaticonAgree.nativeElement
      ) {
        this.opened = false;
        if (this.isMobile) {
          this.alertService.openClosePopUp(false);
        }
      }
    });

    // first set first city which is London
    this._select(this.selectedDepartureNode);

    if (window.innerWidth < 650) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  toggle() {
    this.opened = !this.opened;
    if (this.isMobile) {
      this.alertService.openClosePopUp(this.opened);
    }
  }

  private _select(city: DeparturePoint, airport?: DeparturePoint) {
    if (airport) {
      this.selected = airport;
      this.selectedName = city.name + ' ' + airport.name;
    } else {
      this.selected = city;
      this.selectedName = city.name;
      if (city.children.length > 1)
        return (this.selectedName += ' (All Airports)');
      if (city.children.length) return this.selectedName;
    }
  }

  selectDeparture(city: DeparturePoint, airport?: DeparturePoint) {
    if (airport) {
      this._select(city, airport);
    } else {
      this._select(city);
    }
    this.selectAction.emit({ city: city, airport: airport });
    this.toggle();
  }

  sortedDepartureTree() {
    return this.departureTree.children.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
